module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "captchaModal"
    }
  }, [_c('div', {
    attrs: {
      "id": "captchaContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "headerContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "logoContainer"
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.perguntaCaptcha))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "formularioCaptcha"
    }
  }, [_c('div', {
    attrs: {
      "id": "captchaOnly"
    }
  }, [_c('section', [_c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsA1,
      'border': _vm.borderA1
    }),
    attrs: {
      "id": "LabelA1"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(0, 'LabelA1')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsA2,
      'border': _vm.borderA2
    }),
    attrs: {
      "id": "LabelA2"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(1, 'LabelA2')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsA3,
      'border': _vm.borderA3
    }),
    attrs: {
      "id": "LabelA3"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(2, 'LabelA3')
      }
    }
  })]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsB1,
      'border': _vm.borderB1
    }),
    attrs: {
      "id": "LabelB1"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(3, 'LabelB1')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsB2,
      'border': _vm.borderB2
    }),
    attrs: {
      "id": "LabelB2"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(4, 'LabelB2')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsB3,
      'border': _vm.borderB3
    }),
    attrs: {
      "id": "LabelB3"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(5, 'LabelB3')
      }
    }
  })]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsC1,
      'border': _vm.borderC1
    }),
    attrs: {
      "id": "LabelC1"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(6, 'LabelC1')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsC2,
      'border': _vm.borderC2
    }),
    attrs: {
      "id": "LabelC2"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(7, 'LabelC2')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelsCaptcha",
    style: ({
      'background-color': _vm.backgroundColorsC3,
      'border': _vm.borderC3
    }),
    attrs: {
      "id": "LabelC3"
    },
    on: {
      "click": function($event) {
        return _vm.captchaSelecionado(8, 'LabelC3')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "buttonContainerCaptcha"
    }
  }, [_c('div', {
    attrs: {
      "id": "BotaoSubmit"
    },
    on: {
      "click": function($event) {
        return _vm.responderCaptcha()
      }
    }
  }, [_vm._v("\r\n              Continuar\r\n          ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-1777522a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/captcha/captcha.vue
// module id = 2051
// module chunks = 1